var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_vm._v(" 404 - Component "),_c('b',[_vm._v(_vm._s(_vm.componentName))]),_vm._v(" NOT FOUND ! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }